import React from 'react'

import type { GridRow } from './types'

type Props = {
	value: unknown
	row: GridRow
	linkField?: string
}

export const TruncateLinkCell: React.FC<Props> = ({ value, row, linkField = 'feedbackLink' }) => {
	const text = value === null || value === undefined ? '' : String(value)
	const link = typeof row[linkField] === 'string' ? (row[linkField] as string) : null

	if (text === '') {
		return <span style={{ color: '#9ca3af' }}>—</span>
	}

	const inner = (
		<span
			style={{
				display: 'block',
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				width: '100%',
				color: '#1f2937',
			}}
			title={text}
		>
			{text}
		</span>
	)

	if (link !== null) {
		return (
			<a
				href={link}
				target="_blank"
				rel="noopener noreferrer"
				style={{ display: 'block', width: '100%', color: '#1f2937', textDecoration: 'none' }}
			>
				{inner}
			</a>
		)
	}
	return <div style={{ width: '100%', overflow: 'hidden' }}>{inner}</div>
}
